export const APP_BASE_URL =
  import.meta.env.VITE_APP_URL || "https://app.kargonode.com";

